import PropTypes from "prop-types";
import withViewport from "../Viewport/withViewport";
import { withTranslation } from "@template/components/translation";
import classnames from "classnames";
import styles from "./index.css";
import NameRating from "./NameRating";
import AppLogo from "./AppLogo";
import DownloadAppButton from "./DownloadButton";

const AppDownload = ({
  isSideNavigation,
  isLoggedIn,
  isBrazeInitialised,
  formatTranslation,
  ctaRef,
  defaultStoreUrl,
  variant
}) => {
  if (variant === "banner") {
    return (
      <div className={styles.banner} data-testid="app-download-banner">
        <DownloadAppButton
          ctaRef={ctaRef}
          defaultStoreUrl={defaultStoreUrl}
          classes={styles.bannerButton}
        >
          {formatTranslation("app_download_cta")}
        </DownloadAppButton>
      </div>
    );
  }

  return (
    <section
      className={classnames(styles.container, {
        [styles.sideNavigation]: isSideNavigation,
        [styles.loggedOut]: !isLoggedIn && isBrazeInitialised,
        [styles.loggedIn]: isLoggedIn
      })}
      data-testid="app-download"
    >
      <div className={styles.innerWrapper}>
        <div className={styles.logoContainer}>
          <AppLogo classes={styles.appLogo} />
          <NameRating darkStars={isSideNavigation} />
        </div>
        <div className={styles.ctaContainer}>
          <DownloadAppButton
            ctaRef={ctaRef}
            defaultStoreUrl={defaultStoreUrl}
            classes={styles.ctaButton}
            theme="primary"
          >
            {formatTranslation("app_download_cta")}
          </DownloadAppButton>
        </div>
      </div>
    </section>
  );
};

AppDownload.propTypes = {
  isSideNavigation: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isBrazeInitialised: PropTypes.bool,
  formatTranslation: PropTypes.func,
  ctaRef: PropTypes.string,
  defaultStoreUrl: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["card", "banner"])
};

AppDownload.defaultProps = {
  variant: "card"
};

export default withViewport(withTranslation(AppDownload));
